module.exports = __webpack_public_path__ + "static/rut-fb63a3285ea3d23af272ea4e1fc88d17.pdf";